'use es6';

import I18n from 'I18n';
import { Select } from 'foundations-components/transitional/components/Select';
import { Conditions } from '../../../schema/filter-records';
import { jsx as _jsx } from "react/jsx-runtime";
const SnowflakeFilterConditionSelect = ({
  condition = Conditions.AND,
  onChange,
  readOnly
}) => {
  return /*#__PURE__*/_jsx(Select, {
    "data-test-id": "snowflake-filter-condition-select",
    onChange: ({
      target: {
        value
      }
    }) => onChange(value),
    readOnly: readOnly,
    options: [{
      text: I18n.text('reporting-snowflake.filter-editor.condition-select.AND'),
      value: Conditions.AND
    }, {
      text: I18n.text('reporting-snowflake.filter-editor.condition-select.OR'),
      value: Conditions.OR
    }, {
      text: I18n.text('reporting-snowflake.filter-editor.condition-select.CUSTOM'),
      value: Conditions.CUSTOM
    }],
    value: condition
  });
};
export default SnowflakeFilterConditionSelect;